import {
	PortActionTypes,
	SalinityDensities,
	SalinityTypes,
} from '@shared/utils/constants';
import { calculateTotal } from '@shared/utils/math';
import type { LocalPortRotation } from '@client/screens/estimates/details/context/hooks/usePortRotationHandlers';

export const getDensity = (entry: LocalPortRotation) => (
	entry.density ?? SalinityDensities[entry.salinity ?? SalinityTypes.SALT]
);

export const getDepartureRob = (entry: LocalPortRotation) => {
	const departure = entry.PortCallActions?.find((pca) => pca.event === PortActionTypes.DEPARTURE);

	if (departure == null) {
		return null;
	}

	return calculateTotal(departure.RobBunkers, (rb) => rb.forecastedQuantity ?? 0);
};
